import { render, staticRenderFns } from "./MensualMateriaPrima.vue?vue&type=template&id=ca5691cc&"
import script from "./MensualMateriaPrima.vue?vue&type=script&lang=js&"
export * from "./MensualMateriaPrima.vue?vue&type=script&lang=js&"
import style0 from "./MensualMateriaPrima.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports